// Pure helpers for the reservation CountdownTimer. Kept in a plain .js
// file (no JSX) so the test runner can import them directly under
// Node's ESM loader without a JSX transformer.

export const toMs = (iso) => {
  if (!iso) return NaN;
  const ms = Date.parse(iso);
  return Number.isFinite(ms) ? ms : NaN;
};

export const formatMMSS = (msLeft) => {
  const total = Math.max(0, Math.floor(msLeft / 1000));
  const mm = Math.floor(total / 60);
  const ss = total % 60;
  return `${String(mm).padStart(2, '0')}:${String(ss).padStart(2, '0')}`;
};